import React, { ReactElement, useState } from 'react';
import { CaretDownOutlined, CheckOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import Button from 'antd/es/button';
import Dropdown from 'antd/es/dropdown';
import { MenuProps } from 'antd/es/menu';
import moment from 'moment';
import { MomentDate } from '../../models/date.model';
import { Filter, MenuItem, getItem, getMonthFilterOptions } from '../../shared/helper';

interface MetricsSectionViewContainerProps {
  children: ReactElement;
  onMonthChange: (month: MomentDate) => void;
  dailyKpisLoading: boolean;
  monthlyKpisLoading: boolean;
}

const EmptySpace = () => <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>;

export const MetricsSectionViewContainer = ({
  children,
  onMonthChange,
  dailyKpisLoading,
  monthlyKpisLoading,
}: MetricsSectionViewContainerProps) => {
  const monthFilterOptions: Filter = getMonthFilterOptions();

  const [dropdownOption, setDropdownOption] = useState(Object.keys(monthFilterOptions)[0]);

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    setDropdownOption(e.key);
    onMonthChange(moment(monthFilterOptions[e.key].start));
  };
  const items: MenuItem[] = [
    ...Object.keys(monthFilterOptions).map((key) =>
      getItem(key, key, key === dropdownOption ? <CheckOutlined /> : <EmptySpace />),
    ),
  ];
  if (dailyKpisLoading || monthlyKpisLoading) {
    return (
      <div className="loading">
        <Spin tip="Loading..." />
      </div>
    );
  }
  return (
    <div className="vendor-dashboard-layout">
      <div className="vendor-dashboard-layout-title">
        <Dropdown trigger={['click']} disabled={false} menu={{ items, onClick: handleMenuClick }}>
          <Button>
            {dropdownOption} <CaretDownOutlined />
          </Button>
        </Dropdown>
      </div>
      <div className="vendor-dashboard-layout-container">{children}</div>
    </div>
  );
};
